module.exports = __webpack_public_path__ + "static/media/logn-bg.72598d78.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/logn-bg.png
// module id = 968
// module chunks = 0